import React, { useEffect, createElement } from 'react';
type MetaPixelFunction = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  loaded?: boolean;
  push?: (...args: unknown[]) => void;
  queue?: unknown[][];
  version?: string;
};
declare global {
  interface Window {
    _fbq?: MetaPixelFunction;
    fbq?: MetaPixelFunction;
  }
}
const META_PIXEL_ID = '1322788416056310';
export function MetaPixel() {
  useEffect(() => {
    if (window.fbq) {
      return;
    }
    const fbq = ((...args: unknown[]) => {
      if (fbq.callMethod) {
        fbq.callMethod(...args);
        return;
      }
      fbq.queue?.push(args);
    }) as MetaPixelFunction;
    fbq.loaded = true;
    fbq.version = '2.0';
    fbq.queue = [];
    fbq.push = (...args: unknown[]) => fbq(...args);
    window.fbq = fbq;
    window._fbq = fbq;
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    fbq('init', META_PIXEL_ID);
    fbq('track', 'PageView');
  }, []);
  return null;
}